import './index.scss';

import { Component, ReactNode } from 'react';

import t from 'utils/i18n';
import { BraxButton } from '../BraxButton';
import { BraxModal } from '../BraxModal';

export type BraxNoticeProps = {
    open: boolean,
    size: 'sm' | 'md' | 'lg',
    title: ReactNode,
    className?: string,
    children?: ReactNode
} & ({
    type: 'confirm',
    onConfirm?: () => void,
    onCancel?: () => void
} | {
    type: 'warning',
    onClose?: () => void
});

export class BraxNotice extends Component<BraxNoticeProps> {

    static defaultProps = {
        open: true,
        size: 'md'
    };

    resolve(type: 'onConfirm' | 'onCancel' | 'onClose') {
        this.props[type]?.();
    }

    render() {
        return (
            <BraxModal
                open={this.props.open}
                size={this.props.size}
                className={`brax-notice ${this.props.className || ''}`}
                backdrop={false}
                close={false}
            >
                <h2>{ this.props.title || t('Confirme sua ação') }</h2>

                { this.props.children }

                { this.props.type === 'confirm' ? (
                    <div className="brax-actions-confirm">
                        <BraxButton variant="primary" onClick={() => this.resolve('onConfirm')}>{ t('Sim') }</BraxButton>

                        <BraxButton variant="secondary" onClick={() => this.resolve('onCancel')}>{ t('Não') }</BraxButton>
                    </div>
                ) : (
                    <div className="brax-actions-warning">
                        <BraxButton variant="primary" onClick={() => this.resolve('onClose')}>{ t('Fechar') }</BraxButton>
                    </div>
                ) }
            </BraxModal>
        );
    }

}
